import { observable } from 'mobx';
import { FormikHelpers } from 'formik';
import { API_ACCOUNT_CONTRACT_AML_OWNER, API_ACCOUNT_CONTRACT_AML_OWNERS } from 'api/endpoints';

import { FormStore } from 'stores/formStore';
import { RootStore } from 'stores/rootStore';
import { CompanyOwner, CompanyOwnersData } from './model';

export class CompanyOwnersStore extends FormStore<CompanyOwner> {
  accountId: string;

  @observable ownersData?: CompanyOwnersData;

  constructor(rootStore: RootStore, accountId: string) {
    super(rootStore);
    this.accountId = accountId;
    this.ownersData = undefined;
  }

  fetchOwnersData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<CompanyOwnersData>(
      API_ACCOUNT_CONTRACT_AML_OWNERS(this.accountId),
    );
    if (response?.data) {
      this.ownersData = response.data;
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  fetchOwner = async (ownerId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(API_ACCOUNT_CONTRACT_AML_OWNER(this.accountId, ownerId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  deleteOwner = async (ownerId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.delete(
      API_ACCOUNT_CONTRACT_AML_OWNER(this.accountId, ownerId),
    );
    this.rootStore.stores.uiStore.setLoading(false);
  };

  handleSubmit = async (values: CompanyOwner, formikHelpers: FormikHelpers<CompanyOwner>) => {
    const ok = await this.submitData(API_ACCOUNT_CONTRACT_AML_OWNERS(this.accountId), values, {
      formikHelpers,
      reset: false,
      validationPrefixDepth: 0,
      //singleValueResponse: true,
    });
    return ok ? this.data : null;
  };
}
